import {
  CircleDot, Circle, Square, Maximize2, Maximize,
  Minus, PenLine, Gem, Crown,
  Hand, Crosshair, Footprints,
  Droplets, PaintBucket, Rainbow,
  Ruler, Palette, Layers, MapPin,
} from "lucide-react";

export { SIZES, COMPLEXITIES, PLACEMENTS, COLOR_OPTIONS, ARTIST_RATES, DEFAULT_RATE, SHOP_MINIMUM, calculateEstimate, TEMPLATE_ESTIMATES } from "@shared/estimate-config";
export type { TemplateEstimate } from "@shared/estimate-config";
import { SIZES, COMPLEXITIES, PLACEMENTS, COLOR_OPTIONS } from "@shared/estimate-config";

export const SIZE_ICONS: Record<string, React.ReactNode> = {
  tiny: <CircleDot size={18} />,
  small: <Circle size={18} />,
  medium: <Square size={18} />,
  large: <Maximize2 size={18} />,
  xlarge: <Maximize size={18} />,
};

export const COMPLEXITY_ICONS: Record<string, React.ReactNode> = {
  simple: <Minus size={18} />,
  moderate: <PenLine size={18} />,
  detailed: <Gem size={18} />,
  complex: <Crown size={18} />,
};

export const PLACEMENT_ICONS: Record<string, React.ReactNode> = {
  easy: <Hand size={18} />,
  moderate: <Crosshair size={18} />,
  difficult: <Footprints size={18} />,
};

export const COLOR_ICONS: Record<string, React.ReactNode> = {
  blackgrey: <Droplets size={18} />,
  limited: <PaintBucket size={18} />,
  full: <Rainbow size={18} />,
};

export const STEP_ICON_MAP: Record<string, Record<string, React.ReactNode>> = {
  size: SIZE_ICONS,
  complexity: COMPLEXITY_ICONS,
  placement: PLACEMENT_ICONS,
  color: COLOR_ICONS,
};

export const STEP_COLOR_MAP: Record<string, Record<string, string>> = {
  size: Object.fromEntries(SIZES.map(s => [s.id, s.color])),
  complexity: Object.fromEntries(COMPLEXITIES.map(c => [c.id, c.color])),
  placement: Object.fromEntries(PLACEMENTS.map(p => [p.id, p.color])),
  color: Object.fromEntries(COLOR_OPTIONS.map(c => [c.id, c.color])),
};

export type EstimateSubStep = "size" | "complexity" | "placement" | "color";
export const ESTIMATE_SUB_STEPS: EstimateSubStep[] = ["size", "complexity", "placement", "color"];

export const ESTIMATE_STEP_INFO: Record<EstimateSubStep, { title: string; subtitle: string; icon: React.ReactNode }> = {
  size: { title: "How big is your tattoo?", subtitle: "Size is the biggest factor in pricing", icon: <Ruler size={14} /> },
  complexity: { title: "How detailed is the design?", subtitle: "More detail means more time and artistry", icon: <Layers size={14} /> },
  placement: { title: "Where on your body?", subtitle: "Some areas are trickier to tattoo and may cost more", icon: <MapPin size={14} /> },
  color: { title: "Pick a color palette", subtitle: "Color work generally takes more time than black and grey", icon: <Palette size={14} /> },
};

export function getEstimateOptions(subStep: EstimateSubStep) {
  switch (subStep) {
    case "size": return SIZES.map((s) => ({ id: s.id, label: s.label, description: s.description }));
    case "complexity": return COMPLEXITIES.map((c) => ({ id: c.id, label: c.label, description: c.description }));
    case "placement": return PLACEMENTS.map((p) => ({ id: p.id, label: p.label, description: p.description }));
    case "color": return COLOR_OPTIONS.map((c) => ({ id: c.id, label: c.label, description: c.description }));
  }
}
